import { GetRepeatableSpaceBase } from '../../types/GetRepeatableSpaceBase';
import { getUndefinedRepeatableSpace } from '../../utils/getUndefinedRepeatableSpace';
import { repeatableSpaceFactory } from '../../utils/repeatableSpaceFactory';

// TODO: monkeypatch o algo que me permita agregar info al space para saber que vino de esta función
export const getRepeatableSpaceBancoDeBogota: GetRepeatableSpaceBase = (group, space, context) => {
  const { negBooleans, alternative } = context;
  const {
    isTotalPayment, isInstallmentsPlan, isPrepaymentCompletedOrAfter, isRefinance,
    isBalanceBehindPayment, isBogotaNoPayment, isPaymentPromise, isVirtualDebt,
    isBogotaTermExtension, isSentToBank, isBalanceBehindLowRate,
    isBogotaSpecialCampaign, isBogotaSpecialCampaignLowRate,
  } = negBooleans!;
  const { discountValue, prePayment } = alternative || {};

  switch (group) {
    case 'NEG_OPTION_TERMS': {
      switch (space) {
        case 'rows': {
          const sp = repeatableSpaceFactory('NEG_OPTION_TERMS__rows', [ 'label', 'value' ]);
          if (isTotalPayment) {
            sp.addRows([ 'snr', 'productNumber' ]);
            if (!isPrepaymentCompletedOrAfter) {
              sp.addRow('paymentValue');
              sp.addRow('paymentDate');
              if (discountValue) sp.addRow('discount');
            }
          }
          if (isInstallmentsPlan) {
            sp.addRow('snr');
            if (!isVirtualDebt) sp.addRow('productNumber');
            sp.addRows([ 'monthlyPayment', 'rateEA', 'newTerms' ]);
          }
          if (isRefinance) {
            sp.addRows([ 'newTerms', 'monthlyPayment' ]);
            if (prePayment && !isPrepaymentCompletedOrAfter) {
              sp.addRow('prePayment');
              sp.addRow('prePaymentDate');
            }
            sp.addRow('productNumber');
          }
          if (isBalanceBehindPayment && isBogotaSpecialCampaign) {
            if (!isPrepaymentCompletedOrAfter) {
              sp.addRows([ 'snr', 'productNumber' ]);
              sp.addRow('prePayment');
              sp.addRow('prePaymentDate');
              if (isBogotaSpecialCampaignLowRate) sp.addRow('campaignRateEA');
            } else {
              sp.addRows([ 'afterPayment', 'productNumber' ]);
            }
          } else if (isBalanceBehindPayment && !isBogotaNoPayment && !isBalanceBehindLowRate) {
            if (!isPrepaymentCompletedOrAfter) {
              sp.addRows([ 'snr', 'productNumber' ]);
              // for this option the payment is value, not prePayment
              sp.addRow('paymentValue');
              sp.addRow('paymentDate');
            } else {
              sp.addRows([ 'afterPayment', 'productNumber' ]);
            }
          }
          if (isPaymentPromise && !isPrepaymentCompletedOrAfter) {
            sp.addRow('paymentDate');
          }
          if (isBogotaTermExtension) {
            if (!isPrepaymentCompletedOrAfter && !isSentToBank) {
              sp.addRow('snr'); // REALIZAR EL PAGO A LA CUENTA SNR
              sp.addRow('newTerms'); // PLAZO NUEVO
              sp.addRow('monthlyPayment'); // CUOTA MENSUAL ESTIMADA
              sp.addRow('prePayment'); // ABONO INICIAL REQUERIDO
              sp.addRow('prePaymentDate'); // FECHA LIMITE PARA EL ABONO INICIAL
              sp.addRow('termExtensionRateEA'); // TASA EA
              sp.addRow('productNumber'); // PRODUCTO
            } else {
              sp.addRow('afterPayment');
              sp.addRow('productNumber');
            }
            // PRODUCTO
          }
          return sp.get();
        }
        default: break;
      }
      break;
    }
    default: break;
  }

  return getUndefinedRepeatableSpace();
};
